// Pure rules for running check-in surveys: which lifecycle actions a check-in
// offers in the state it is in, and the words that go with them. Kept out of the
// components so the rules can be unit-tested without rendering the page.

// Status values as Custom-Api's CheckInStatus enum defines them.
export const CHECK_IN_STATUS = {
  published: 1,
  running: 2,
  closed: 3,
  cancelled: 4,
  paused: 5,
}

export const CHECK_IN_ACTION = {
  pause: 'pause',
  resume: 'resume',
  stop: 'stop',
}

// Pausing leaves the check-in that is already open alone and only stops the next
// one launching, so a paused suite can still be resumed or stopped for good.
const ACTIONS_BY_STATUS = {
  [CHECK_IN_STATUS.running]: [CHECK_IN_ACTION.pause, CHECK_IN_ACTION.stop],
  [CHECK_IN_STATUS.paused]: [CHECK_IN_ACTION.resume, CHECK_IN_ACTION.stop],
}

export const lifecycleActionsFor = status => ACTIONS_BY_STATUS[status] ?? []

export const isPaused = status => status === CHECK_IN_STATUS.paused

export const PAUSED_EXPLANATION =
  'The current check-in stays open until its end date; no new check-ins will launch until you resume.'

export const STOP_CONFIRMATION =
  'Stop this check-in? The current one stays open until its end date; no more will launch. You can set up a new one afterwards.'

const ACTION_LABELS = {
  [CHECK_IN_ACTION.pause]: 'Pause',
  [CHECK_IN_ACTION.resume]: 'Resume',
  [CHECK_IN_ACTION.stop]: 'Stop',
}

export const lifecycleActionLabel = action => ACTION_LABELS[action] ?? ''

const ACTION_FAILURE_MESSAGES = {
  [CHECK_IN_ACTION.pause]:
    'We could not pause this check-in. Please try again.',
  [CHECK_IN_ACTION.resume]:
    'We could not resume this check-in. Please try again.',
  [CHECK_IN_ACTION.stop]: 'We could not stop this check-in. Please try again.',
}

export const lifecycleFailureMessage = action =>
  ACTION_FAILURE_MESSAGES[action] ??
  'We could not update this check-in. Please try again.'
